import React from 'react'
import Button from 'antd/lib/button'
import Modal from 'antd/lib/modal'
import { useSelector } from 'react-redux'
import { API, graphqlOperation } from 'aws-amplify'
import { useGenerateHSKWithoutEmail } from '../customHooks'
import { message } from 'antd'

const op = `mutation createIamSafe($input: iamSafeInput) {
    createIamSafe(input: $input) {
        sk
        d1
        email
        phone
        createdAt
        floor
        firstName
        lastName
        suite
        tenant
        building
    }
}`

const styles = {
    button: {
        marginTop: 15,
        marginRight: 15,
        float: 'right',
        color: 'white',
        backgroundColor: '#0eb20e',
        borderColor: '#0eb20e'
    }
}

const IamSafeButton = () => {

    const iamSafeActive = useSelector(state => state.app.building?.settings?.modules?.find((item) => item.key === 'imsafe').enabled)
    const user = useSelector(state => state.app.user)
    const building = useSelector(state => state.app.building.name)
    const tenant = useSelector(state => state.app.tenant.name)

    const d1 = useGenerateHSKWithoutEmail()

    if (!iamSafeActive) return null


    const saveIamSafeData = async () => {
        const data = {
            sk: 'IAM_SAFE',
            d1: d1,
            email: user.email,
            phone: user.phoneNumber ? user.phoneNumber : user.workPhone,
            firstName: user.firstName,
            lastName: user.lastName,
            floor: user.floor,
            suite: user.suite,
            createdAt: Date.now(),
            tenant: tenant,
            building: building
        }

        try {
            return await API.graphql(graphqlOperation(op, { input: data }))
        } catch (e) {
            console.log("error: ", e)
            throw new Error(JSON.stringify(e, null, 4))
        }
    }

    const onIamSafe = async () => {
        const modal = Modal.confirm({
            title: 'Confirm I’m Safe?',
            content: 'Click Confirm button to log in the system that you are safe.',
            okText: "Confirm",
            onOk() {
                return new Promise((resolve, reject) => {
                    saveIamSafeData().then(() => {
                        message.success("You have successfully communicated you are safe")
                        modal.destroy()
                    })
                }).catch(() => message.error("Could not send data to admins"))
            },
            onCancel() {
                message.warning("You have cancelled communicating you are safe")
            },
        });
    }

    return (
        <Button
            style={styles.button}
            onClick={onIamSafe}>
            I'm Safe
        </Button>
    )
}

export default IamSafeButton